<template>

  <div class="user">
    <!--内容-->
    <div class="product-content">
      <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="门店名称"><el-input size="small" v-model="searchForm.store_name" placeholder="请输入门店名称"></el-input></el-form-item>
        <el-form-item label="门店id"><el-input size="small" v-model="searchForm.store_id" placeholder="请输入门店名称"></el-input></el-form-item>
        

        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        
      </el-form>
    </div>
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="store_id" label="门店ID" width="60"></el-table-column>
          <el-table-column label="Logo" width="60">
            <template slot-scope="scope">
              <img v-if="scope.row.logo" v-img-url="scope.row.logo.file_path" width="30px" height="30px" />
            </template>
          </el-table-column>
          <el-table-column prop="store_name" label="门店名称"></el-table-column>
          <el-table-column prop="shop_hours" label="营业时间"></el-table-column>
          <el-table-column prop="shopManager.user.nickName" label="店长"></el-table-column>
          <el-table-column prop="linkman" label="联系人"></el-table-column>
          <el-table-column prop="phone" label="联系电话" width="100"></el-table-column>
          <el-table-column prop="detail_address" label="门店地址" width="240"></el-table-column>
          <el-table-column prop="is_check" label="自提核销">
            <template slot-scope="scope">
              <span :class="{ green: scope.row.is_check.value == 1, gray: scope.row.is_check.value == 0 }">{{ scope.row.is_check.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="门店状态">
            <template slot-scope="scope">
              <span :class="{ green: scope.row.status.value == 1, gray: scope.row.status.value == 0 }">{{ scope.row.status.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="140"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="listClick(scope.row.store_id)" type="text" size="small" v-auth="'/plus/distribution/store/handle'">配送管理</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Handle
        v-if="open_list"
        :open_list="open_list"
        :store_id="store_id"
        @closeDialog="closeDialog"
      ></Handle>
      
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import StoreApi from '@/api/store.js';
import Handle from './handle.vue';
export default {
  components: {
    Handle,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        store_name:"",
        store_id: '',
      },
      store_id:0,
      /*是否打开添加弹窗*/
      open_add: false,
      open_list: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      StoreApi.shoplist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick(store_id) {
      this.open_add = true;
      this.store_id = store_id;
    },
    listClick(store_id) {
      this.open_list = true;
      this.store_id = store_id;
    },
    /* 关闭编辑框 */
    async closeDialog(reflush = false) {
      this.open_add = false;
      this.open_list = false;
    },
     onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getTableList();
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/distribution/store/index.vue